// Route Constants
// Centralized route path definitions for the application

export const PUBLIC_ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  COURSES: '/courses',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  REFUND_POLICY: '/refund-policy',
  COOKIE_POLICY: '/cookie-policy',
  EMAIL_VERIFICATION: '/verify-email',
  PARENT_VERIFICATION: '/verify-parent/:studentId/:token'
};

export const PROTECTED_ROUTES = {
  DASHBOARD: '/dashboard',
  MY_COURSES: '/dashboard?tab=courses',
  COURSE_DETAIL: '/dashboard/courses/:courseId',
  LESSON: '/dashboard/courses/:courseId/lessons/:lessonId',
  COURSE_PLAYER: '/course-player/:courseId',
  EXAM: '/courses/:courseId/exam',
  PROGRESS: '/dashboard?tab=progress',
  PROFILE: '/dashboard/profile',
  PROFILE_VIEW: '/dashboard/profile/:userId',
  CERTIFICATES: '/dashboard?tab=certificates',
  CERTIFICATE_VIEW: '/dashboard/certificates/view',
  PAYMENT_HISTORY: '/dashboard?tab=payments',
  PAYMENT_SUCCESS: '/payment-success'
};

export const ADMIN_ROUTES = {
  ADMIN_DASHBOARD: '/admin',
  MANAGE_USERS: '/admin/users',
  MANAGE_COURSES: '/admin/courses',
  MANAGE_LESSONS: '/admin/lessons',
  ANALYTICS: '/admin/analytics',
  SETTINGS: '/admin/settings',
  AUDIT_LOGS: '/admin/audit-logs',
  SECURITY_MANAGEMENT: '/admin/security-management',
  MANAGE_ENROLLMENTS: '/admin/enrollments',
  PERFORMANCE: '/admin/performance',
  WEB_VITALS: '/admin/web-vitals',
  SCHEDULING: '/admin/scheduling',
  COMPLIANCE_REPORTS: '/admin/compliance-reports',
  DETS_EXPORT: '/admin/dets-export',
  SUPPORT: '/admin/support'
};

export const INSTRUCTOR_ROUTES = {
  INSTRUCTOR_DASHBOARD: '/instructor',
  MY_STUDENTS: '/instructor/students',
  MY_COURSES: '/instructor/courses',
  SCHEDULE: '/instructor/schedule'
};

// Helper function to build dynamic routes
export const buildRoute = (route, params = {}) => {
  let path = route;
  Object.keys(params).forEach(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
